import { type FC, useState } from 'react';

import TextField from '../../../ui/input_field/input_field';

import styles from './password.module.css';

export type ValueType = string | undefined;

export type PasswordProps = {
  show?: boolean;
  onChange?: (value: ValueType) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  value?: ValueType;
  type?: string;
  inputMode?:
    | 'none'
    | 'text'
    | 'tel'
    | 'url'
    | 'email'
    | 'numeric'
    | 'decimal'
    | 'search';
  autoFocus?: boolean;
};

const Password: FC<PasswordProps> = (props) => {
  const [show, setShow] = useState(props.show);

  const onShow = (): void => {
    setShow(!show);
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.button}
        onClick={onShow}
        type="button"
        tabIndex={-1}
      >
        {show ? 'Hide' : 'Show'}
      </button>
      <TextField {...props} type={show ? 'text' : 'password'} />
    </div>
  );
};

export default Password;
